import { Link } from "react-router-dom";
import { ImageOff } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { fileUrl } from "@/lib/api";

export const ProductImage = ({ path, alt, className = "" }) =>
  path ? <img src={fileUrl(path)} alt={alt} loading="lazy" decoding="async" className={`w-full h-full object-cover ${className}`} />
       : <div className={`w-full h-full flex items-center justify-center bg-[#F3F4F6] text-[#9CA3AF] ${className}`}><ImageOff className="w-8 h-8" /></div>;

export default function ProductCard({ p, i = 0 }) {
  const { t, pick, money } = useI18n();
  return (
    <Link to={`/p/${p.slug}`} data-testid={`product-card-${p.slug}`} className="group card overflow-hidden flex flex-col rise hover:shadow-[0_20px_40px_-20px_rgba(11,13,15,0.25)] transition-shadow duration-300" style={{ animationDelay: `${i * 60}ms` }}>
      <div className="relative aspect-square overflow-hidden bg-[#F5F7FA]">
        <ProductImage path={p.images?.[0]?.path} alt={pick(p.name)} className="group-hover:scale-[1.04] transition-transform duration-500" />
        {p.discount_pct > 0 && <span className="absolute top-3 start-3 chip bg-[#DC2626] text-white">-{p.discount_pct}%</span>}
        {!p.in_stock && <span className="absolute top-3 end-3 chip bg-[#0B0D0F] text-white">{t("product.out_of_stock")}</span>}
      </div>
      <div className="p-4 flex flex-col gap-2 flex-1">
        <h3 className="text-sm font-medium text-[#111827] line-clamp-2 leading-relaxed min-h-[2.75rem]">{pick(p.name)}</h3>
        <div className="mt-auto flex items-baseline gap-2">
          <span data-testid="product-card-price" className="font-display text-lg font-bold text-[#0B0D0F]">{money(p.price)}</span>
          {p.compare_at_price > p.price && <span className="text-xs text-[#6B7280] line-through">{money(p.compare_at_price)}</span>}
        </div>
      </div>
    </Link>
  );
}
